const isLocal = window.location.hostname === 'localhost';

const config = {
  basename: '/',
  defaultPath: '',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,

  backend_Url: 'https://uatkeibiaivayona.inteliquantai.com/api/v1',


  // MICROSOFT SSO CONFIG
  msal: {
    clientId: 'ff26af12-11c6-4c5d-afbf-048b301a275e',
    authority: 'https://login.microsoftonline.com/2b1250e4-87e3-4e23-a3a7-7645f5297c09',

    redirectUri: isLocal ? 'http://localhost:3000/auth/callback' : 'https://uatkeibiaivayona.inteliquantai.com/auth/callback',

    postLogoutRedirectUri: isLocal ? 'http://localhost:3000' : 'https://keibiai.inteliquantai.com'
  },

};

export default config;